import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { createContact, editContact } from 'lib/api';
import BusinessSearcherAutocomplete from 'lib/common/BusinessSearcherAutocomplete';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { createContactValidation, showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { ContactForm } from '../../../../../BusinessProfile/Profile/components/Contacts';

const NewContact = (props: any) => {
  const { contact, setContact, setOpen, open, setUp } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [business, setBusiness] = useState<any>(null);
  const [searched, setSearched] = useState(false);

  const validateAttributes = () => {
    if (!createContactValidation(contact, dispatch)) return false;
    return true;
  };

  const handleSubmit = async () => {
    if (!validateAttributes()) return;
    setLoading(true);
    try {
      if (contact.id) {
        await editContact(dispatch, contact.id, {
          name: contact.name,
          email: contact.email,
          role: contact.role,
          phone: contact.phone,
          customRole: contact.customRole,
        });
        showAlert(dispatch, 'success', 'Contacto editado con éxito');
      } else {
        await createContact(dispatch, {
          ...contact,
          businessIdentifier: business.identifier,
        });
        showAlert(dispatch, 'success', 'Contacto creado con éxito');
      }
      setOpen(false);
      await setUp();
    } catch (error) {
      showAlert(dispatch, 'error', 'Ha ocurrido un error');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        {contact.id ? 'Editar contacto' : 'Nuevo contacto'}
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <div>
            {!contact.id && (
              <div>
                <BusinessSearcherAutocomplete
                  setBusiness={setBusiness}
                  setSearched={setSearched}
                />
              </div>
            )}
            {contact.id && searched && <Divider />}

            {(business || contact.id) && (
              <div style={{ padding: '10px 0px' }}>
                <ContactForm
                  selectedContact={contact}
                  setSelectedContact={setContact}
                />
              </div>
            )}
            {!business && searched && (
              <div style={{ padding: '10px 0px' }}>
                <Typography>
                  No encontramos una empresa con ese rut en tu red. Por favor
                  verifica el rut o crea la empresa antes de agregar un
                  contacto.
                </Typography>
              </div>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Cancelar
        </CustomButton>
        <CustomButton
          disabled={!business && !contact.id}
          color="primary"
          onClick={() => handleSubmit()}
        >
          {contact.id ? 'Guardar' : 'Crear'}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewContact;
